import React from "react";
import "./userDetailsModal.css";
import { IoClose } from "react-icons/io5";
import { TbWorld } from "react-icons/tb";
import { useMediaQuery } from "react-responsive";
import { useSelector } from "react-redux";

const UserDetailsModal = ({ isOpen, onClose, user }) => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const { language } = useSelector((state) => state.language);
  if (!isOpen) return null;
  return (
    <div className="userdetailsmodal-container">
      {isMobile === true && (
        <IoClose
          style={{
            fontSize: isMobile === false ? "20px" : "30px",
            right: "10px",
            top: "5px",
            position: "absolute",
            cursor: "pointer",
            color: isMobile === false ? "#0D1B2A" : "black",
            zIndex:9999999
          }}
          onClick={onClose}
        />
      )}
      <div
        className="userdetailsmodal-mid-container"
        style={{
          maxWidth: isMobile === false && "900px",
          maxHeight: isMobile === false && "542px",
        }}
      >
        <div className="userdetailsmodal-mid-sub-container">
          {isMobile === false && (
            <IoClose
              style={{
                fontSize: isMobile === false ? "20px" : "30px",
                top: isMobile === false ? "10px" : "-30px",
                right: "10px",
                position: "absolute",
                cursor: "pointer",
                color: isMobile === false ? "#0D1B2A" : "white",
              }}
              onClick={onClose}
            />
          )}
          <img
            className="userdetailsmodal-mid-container-img"
            alt=""
            src={`assets/images/${user?.imageName}`}
          />
          <div className="userdetailsmodal-mid-container-right-div">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                gap: "5px",
                width: "100%",
              }}
            >
              <span
                className="textFlex"
                style={{
                  fontWeight: "600",
                  fontSize: isMobile === false ? "32px" : "24px",
                  color: "#100F0D",
                  textTransform: "uppercase",
                }}
              >
                {language.value === "tr"
                  ? user?.fullName.toLocaleUpperCase("tr-TR")
                  : user?.fullName.toLocaleUpperCase("en-US")}
              </span>
              <span
                className="textMono"
                style={{
                  fontSize: "16px",
                  textTransform: "uppercase",
                  lineHeight: "140%",
                }}
              >
                {language.value === "tr"
                  ? user?.profession.toLocaleUpperCase("tr-TR")
                  : user?.profession.toLocaleUpperCase("en-US")}
              </span>
              <hr style={{ border: "1px solid #100F0D33", width: "100%" }} />
              <div
                style={{
                  maxWidth: "410px",
                  width: "100%",
                  gap: "20px",
                  display: "flex",
                  flexDirection: "column",
                  marginBottom: "20px",
                }}
              >
                <span
                  className="textFlex"
                  style={{
                    width: "100%",
                    fontWeight: "400",
                    fontSize: "16px",
                    lineHeight: "140%",
                    maxHeight: isMobile === false && "300px",
                    height: "auto",
                    overflowY: isMobile === false && "auto",
                    display: "block",
                  }}
                >
                  {user?.description}
                </span>
                {user?.url !== undefined && (
                  <a
                    href={user?.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none" }}
                  >
                    <TbWorld
                      style={{
                        fontSize: "26px",
                        color: "#100F0D",
                        cursor: "pointer",
                      }}
                    />
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDetailsModal;
